import React from 'react';

import Pagination from '@mui/material/Pagination';
import { SxProps, Theme } from '@mui/system';

type Props = {
  count: number;
  onChange:
    | ((event: React.ChangeEvent<unknown>, page: number) => void)
    | undefined;
  page: number;
  siblingCount?: number;
  boundaryCount?: number;
  sx?: SxProps<Theme>;
  disabled?: boolean;
  onMouseEnter?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
};

const PaginationControl: React.FC<Props> = ({
  count,
  onChange,
  page,
  siblingCount = 1,
  boundaryCount = 1,
  sx,
  disabled = false,
  onMouseEnter,
}) => {
  return (
    <Pagination
      sx={{
        '.MuiPagination-ul': {
          justifyContent: 'center',
        },
        'ul > li .MuiButtonBase-root': {
          borderRadius: '12px',
        },
        '& ul > li:not(:first-of-type):not(:last-of-type) > button:not(.Mui-selected)':
          {
            borderWidth: '1px',
            borderColor: '#266071',
            borderStyle: 'solid',
          },
        'ul > li:first-of-type > button, ul > li:last-of-type > button': {
          backgroundColor: '#D9E9ED',
        },
        '& .MuiPaginationItem-icon': {
          color: '#266071',
        },
        ...sx,
      }}
      style={{
        marginTop: 16,
        maxWidth: '100%',
      }}
      count={count}
      variant='text'
      size='medium'
      color='secondary'
      onChange={onChange}
      page={page}
      siblingCount={siblingCount}
      boundaryCount={boundaryCount}
      disabled={disabled}
      onMouseEnter={onMouseEnter}
    />
  );
};

export default PaginationControl;
